module.exports = __webpack_public_path__ + "img/6.3973f097.jpg";